import React, { useEffect, useState } from "react";
import SkyLayout from "./SkyLayout";
import moment from "moment";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { isMobile } from "react-device-detect";
import WebSkyLayout from "./WebSky/WebSkyLayout";
const ResultSky = () => {
  const [list, setList] = useState([]);
  var previousDate = moment().subtract(1, "days").format("YYYY-MM-DD");
  var currentDate = moment().format("YYYY-MM-DD");
  const [type, setType] = useState("today");
  const [filter, setFilter] = useState({
    fromPeriod: currentDate,
    toPeriod: currentDate,
    gameType: "cricket",
    page: 1,
    limit: 100,
  });

  const getTournamentData = async () => {
    const { status, data: response_users } = await apiGet(apiPath.resultList, {
      ...filter,
      fromPeriod: type == "today" ? currentDate : previousDate,
      toPeriod: currentDate,
    });
  
      if (response_users.success) {
        setList(response_users?.data);
      }
    
  };

  //   useEffect(() => {
  //     getTournamentData();
  //   }, []);
  //   useEffect(() => {
  //     getTournamentData();
  //   }, [type, filter?.gameType]);

  const tabs = [
    { key: "today", label: "Today" },
    { key: "yesterday", label: "Yesterday" },
  ];
  return isMobile ? (
    <SkyLayout>
      <main
        data-v-5f019df8
        className="default-layout relative bg-grey-100 pb-66px"
        style={{ "min-height": "calc(660px)" }}
      >
        <div data-v-27f341c4 className="result-tabs-container">
          <ul data-v-9c2d9adb data-v-27f341c4 className="tabs-container mb-7px">
            <li
              onClick={() => {
                setType("today");
              }}
              className={type == "today" ? "selected tab" : "tab"}
              data-v-9c2d9adb
            >
              Today
            </li>
            <li
              className={type == "Yesterdy" ? "selected tab" : "tab"}
              onClick={() => {
                setType("Yesterdy");
              }}
              data-v-9c2d9adb
            >
              Yesterday
            </li>
          </ul>
          <div data-v-e7872b57 data-v-27f341c4 className="select-container">
            <select
              style={{
                padding: "7px",
                width: "100%",
                borderRadius: "5px",
                fontSize: "16px",
              }}
              value={filter?.gameType}
              onChange={(e) =>
                setFilter((prev) => {
                  return { ...prev, gameType: e.target.value };
                })
              }
            >
              <option value={"cricket"}>Cricket</option>
              <option value={"soccer"}>Soccer</option>{" "}
              <option value={"tennis"}>Tennis</option>
            </select>
            {/**/}
          </div>
        </div>
        <div data-v-27f341c4 className="result-events-container">
          <div data-v-618258ec data-v-27f341c4 className="results-event">
            <div data-v-618258ec className="results-event-team-wrap">
              <div data-v-618258ec className="results-event-team-date">
                2026-01-13 09:30
              </div>
              <div data-v-618258ec className="results-event-team">
                Red Caps Cc v Lion Warriors Cc
              </div>
            </div>
            <div data-v-618258ec className="results-event-score-wrap">
              <div data-v-618258ec className="results-event-score-title">
                Home
              </div>
              <div data-v-618258ec className="results-event-score">
                114/9
              </div>
            </div>
            <div data-v-618258ec className="results-event-score-wrap">
              <div data-v-618258ec className="results-event-score-title">
                Away
              </div>
              <div data-v-618258ec className="results-event-score">
                115/9
              </div>
            </div>
          </div>
        </div>
      </main>
    </SkyLayout>
  ) : (
    <WebSkyLayout>
      <div id="centerColumn" className="col-center inplay">
        <div data-v-50e6bdb6 className="result-tabs-container">
          <ul style={{ marginTop: "10px" }} id="inPlayTab" className="tab col3">
            {tabs.map((tab) => (
              <li>
                <a
                  onClick={(e) => {
                    e.preventDefault(); // stop navigation
                    setType(tab.key);
                  }}
                  id="inPlay"
                  href="#InPlay"
                  className={type === tab.key ? "select" : ""}
                >
                  {tab.label}
                </a>
              </li>
            ))}
          </ul>
          <div
            data-v-7ecfe6b4
            data-v-50e6bdb6
            className="select-container select-menu w-180px"
          >
            <select
              style={{
                width: "120px",
              }}
              value={filter?.gameType}
              onChange={(e) =>
                setFilter((prev) => {
                  return { ...prev, gameType: e.target.value };
                })
              }
            >
              <option value={"cricket"}>Cricket</option>
              <option value={"soccer"}>Soccer</option>{" "}
              <option value={"tennis"}>Tennis</option>
            </select>
          </div>
        </div>
        <div data-v-50e6bdb6 className="result-events-container">
          <div data-v-8a96ecd8 className="results-title">
            Result
          </div>
          <div data-v-8a96ecd8 className="results-events-container">
            <div
              data-v-d2285b4e
              data-v-8a96ecd8
              className="table-container"
              style={{
                "--v2a6fb982":
                  "minmax(auto, 20%) 1fr minmax(auto, 20%) minmax(auto, 20%)",
              }}
            >
              <div
                data-v-d2285b4e
                className="table-thead results-events-table-header"
              >
                <div
                  data-v-7328381c
                  data-v-d2285b4e
                  className="table-td px-10px py-6px left font-bold"
                >
                  Event Date/Time
                </div>
                <div
                  data-v-7328381c
                  data-v-d2285b4e
                  className="table-td px-10px py-6px left font-bold"
                >
                  Event Name
                </div>
                <div
                  data-v-7328381c
                  data-v-d2285b4e
                  className="table-td px-10px py-6px right font-bold"
                >
                  Home
                </div>
                <div
                  data-v-7328381c
                  data-v-d2285b4e
                  className="table-td px-10px py-6px right font-bold"
                >
                  Away
                </div>
              </div>
              <div data-v-d2285b4e className="table-tbody">
                <div data-v-d2285b4e className="table_row">
                  <div
                    data-v-7328381c
                    data-v-d2285b4e
                    className="table-td px-10px py-6px left font-normal"
                  >
                    2026-01-13 09:30
                  </div>
                  <div
                    data-v-7328381c
                    data-v-d2285b4e
                    className="table-td px-10px py-6px left font-normal"
                  >
                    Red Caps Cc v Lion Warriors Cc
                  </div>
                  <div
                    data-v-7328381c
                    data-v-d2285b4e
                    className="table-td px-10px py-6px right font-normal"
                  >
                    <p data-v-8a96ecd8 className="font-bold">
                      114/9
                    </p>
                  </div>
                  <div
                    data-v-7328381c
                    data-v-d2285b4e
                    className="table-td px-10px py-6px right font-normal"
                  >
                    <p data-v-8a96ecd8 className="font-bold">
                      115/9
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>{" "}
    </WebSkyLayout>
  );
};

export default ResultSky;
